import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

export default function renderEntryPoint({
  router: Router,
  rootSelector = '#container',
}) {
  const rootNode = document.querySelector(rootSelector);
  const supportsHistory = 'pushState' in window.history;

  const render = (Component) => {
    ReactDOM.hydrate((
      <HelmetProvider>
        <BrowserRouter forceRefresh={!supportsHistory}>
          <Component />
        </BrowserRouter>
      </HelmetProvider>
    ), rootNode);
  };

  render(Router);
}
